import { render } from "./DataPreparationSaveDialog.vue?vue&type=template&id=0dd97eba&ts=true"
import script from "./DataPreparationSaveDialog.vue?vue&type=script&lang=ts"
export * from "./DataPreparationSaveDialog.vue?vue&type=script&lang=ts"

import "./DataPreparationSaveDialog.vue?vue&type=style&index=0&id=0dd97eba&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__